export const servicesData = {
  'corporate-business-contracts': {
    title: 'Corporate & Business Contracts',
    description: 'Expert contract drafting, review, and negotiation services for businesses of all sizes.',
    image: 'https://images.unsplash.com/photo-1666018215790-867b14fe4822?crop=entropy&cs=srgb&fm=jpg&q=85',
    image2: 'https://images.unsplash.com/photo-1632433339330-f46c673854c0?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'Our experienced attorneys provide comprehensive contract services to protect your business interests. From simple agreements to complex multi-party contracts, we ensure your legal documents are precise, enforceable, and aligned with your business objectives.',
    process: [
      { step: 'Initial Consultation', description: 'We discuss your business needs and contract requirements' },
      { step: 'Drafting & Review', description: 'Our team creates or reviews contracts with meticulous attention to detail' },
      { step: 'Negotiation', description: 'We negotiate terms that protect your interests' },
      { step: 'Finalization', description: 'Final review and execution of agreements' }
    ],
    benefits: [
      'Protection against legal disputes',
      'Clear definition of rights and obligations',
      'Risk mitigation and liability limitation',
      'Professional negotiation support',
      'Compliance with applicable laws'
    ],
    faqs: [
      { q: 'What types of contracts do you handle?', a: 'We handle all business contracts including employment agreements, vendor contracts, partnership agreements, NDAs, and more.' },
      { q: 'How long does contract drafting take?', a: 'Timeline varies based on complexity, typically 3-7 business days for standard contracts.' },
      { q: 'Do you review existing contracts?', a: 'Yes, we provide thorough contract review services to identify potential issues and suggest improvements.' }
    ]
  },
  'corporate-business-formation': {
    title: 'Corporate & Business Formation',
    description: 'Strategic guidance for establishing and structuring your business entity.',
    image: 'https://images.unsplash.com/photo-1745920770891-b46fc1799646?crop=entropy&cs=srgb&fm=jpg&q=85',
    image2: 'https://images.unsplash.com/photo-1716302543659-2bf232d711f5?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'Starting a business requires careful legal planning. We guide you through entity selection, formation documents, and compliance requirements to establish a solid legal foundation for your venture.',
    process: [
      { step: 'Business Assessment', description: 'We evaluate your business goals and recommend optimal entity structure' },
      { step: 'Entity Formation', description: 'File necessary documents with state and federal agencies' },
      { step: 'Governance Setup', description: 'Draft bylaws, operating agreements, and corporate governance documents' },
      { step: 'Compliance Planning', description: 'Establish ongoing compliance requirements and schedules' }
    ],
    benefits: [
      'Limited liability protection',
      'Tax optimization strategies',
      'Enhanced credibility with partners and investors',
      'Clear ownership and management structure',
      'Compliance with regulatory requirements'
    ],
    faqs: [
      { q: 'Which entity type is right for my business?', a: 'The best entity depends on your business goals, liability concerns, and tax situation. We help you evaluate LLC, Corporation, Partnership, and other options.' },
      { q: 'How long does business formation take?', a: 'Most formations are completed within 2-4 weeks, depending on state processing times.' },
      { q: 'What ongoing compliance is required?', a: 'Requirements vary by entity type but typically include annual reports, tax filings, and maintaining corporate records.' }
    ]
  },
  'business-transactions': {
    title: 'Business Transactions',
    description: 'Comprehensive legal support for complex business deals and transactions.',
    image: 'https://images.unsplash.com/photo-1752159400890-d906038f1b35?crop=entropy&cs=srgb&fm=jpg&q=85',
    image2: 'https://images.unsplash.com/photo-1762429648253-b8bc921c8b30?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'Navigate complex business transactions with confidence. Our attorneys provide strategic advice and meticulous execution for asset purchases, stock sales, joint ventures, and strategic partnerships.',
    process: [
      { step: 'Transaction Planning', description: 'Define objectives and structure the optimal transaction framework' },
      { step: 'Due Diligence', description: 'Comprehensive review of legal, financial, and operational matters' },
      { step: 'Documentation', description: 'Draft and negotiate all transaction agreements' },
      { step: 'Closing & Post-Closing', description: 'Manage closing process and post-transaction integration' }
    ],
    benefits: [
      'Strategic transaction structuring',
      'Risk identification and mitigation',
      'Favorable deal terms negotiation',
      'Smooth transaction execution',
      'Post-closing support'
    ],
    faqs: [
      { q: 'What is due diligence?', a: 'Due diligence is a comprehensive investigation of a business before completing a transaction to identify potential risks and liabilities.' },
      { q: 'How long do business transactions take?', a: 'Timeline varies significantly based on transaction complexity, typically 2-6 months from initial agreement to closing.' },
      { q: 'What costs are involved?', a: 'Costs include legal fees, due diligence expenses, and filing fees. We provide transparent estimates based on transaction scope.' }
    ]
  },
  'mergers-acquisitions': {
    title: 'Mergers & Acquisitions',
    description: 'Strategic legal counsel for M&A transactions of all sizes.',
    image: 'https://images.unsplash.com/photo-1770943558988-2c605d6bd5a7?crop=entropy&cs=srgb&fm=jpg&q=85',
    image2: 'https://images.unsplash.com/photo-1716302567933-4debb3605805?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'Whether buying, selling, or merging businesses, our M&A team provides end-to-end legal support. We handle complex negotiations, regulatory compliance, and integration planning to ensure successful transactions.',
    process: [
      { step: 'Strategic Planning', description: 'Define M&A objectives and identify target opportunities' },
      { step: 'Valuation & Due Diligence', description: 'Assess business value and conduct thorough legal review' },
      { step: 'Deal Structure & Negotiation', description: 'Structure optimal deal terms and negotiate agreements' },
      { step: 'Regulatory Approval', description: 'Secure necessary regulatory approvals and clearances' },
      { step: 'Integration Support', description: 'Facilitate post-merger integration and compliance' }
    ],
    benefits: [
      'Expert deal structuring',
      'Comprehensive due diligence',
      'Regulatory compliance management',
      'Risk mitigation strategies',
      'Maximized transaction value'
    ],
    faqs: [
      { q: 'What is the difference between a merger and acquisition?', a: 'A merger combines two companies into one entity, while an acquisition is when one company purchases another. Legal and tax implications differ.' },
      { q: 'How are M&A transactions valued?', a: 'Valuation considers multiple factors including assets, revenue, EBITDA, market conditions, and strategic value.' },
      { q: 'What regulatory approvals are needed?', a: 'Requirements vary by industry and transaction size, but may include antitrust clearance, industry-specific approvals, and foreign investment reviews.' }
    ]
  },
  'non-profit-law': {
    title: 'Non-Profit Law',
    description: 'Legal services for establishing and maintaining tax-exempt organizations.',
    image: 'https://images.unsplash.com/photo-1752159400890-d906038f1b35?crop=entropy&cs=srgb&fm=jpg&q=85',
    image2: 'https://images.unsplash.com/photo-1544377193-33dcf4d68fb5?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'Our non-profit practice helps organizations achieve and maintain tax-exempt status while ensuring ongoing compliance with federal and state regulations. We support your mission with sound legal guidance.',
    process: [
      { step: 'Formation Planning', description: 'Determine appropriate entity structure and tax-exempt status' },
      { step: 'IRS Application', description: 'Prepare and file Form 1023 or 1023-EZ for 501(c)(3) status' },
      { step: 'Governance Setup', description: 'Draft bylaws, conflict of interest policies, and board procedures' },
      { step: 'Ongoing Compliance', description: 'Annual filings, reporting, and regulatory compliance support' }
    ],
    benefits: [
      'Tax-exempt status acquisition',
      'Eligibility for grants and donations',
      'Limited liability protection',
      'Enhanced public credibility',
      'Ongoing compliance support'
    ],
    faqs: [
      { q: 'How long does 501(c)(3) approval take?', a: 'IRS processing times vary but typically range from 3-12 months depending on application complexity and IRS workload.' },
      { q: 'What are the ongoing compliance requirements?', a: 'Non-profits must file annual Form 990, maintain proper records, follow bylaws, and comply with state registration requirements.' },
      { q: 'Can non-profits make a profit?', a: 'Non-profits can generate surplus revenue, but all profits must be reinvested in the organization\'s mission, not distributed to individuals.' }
    ]
  },
  'government-contracting': {
    title: 'Government Contracting',
    description: 'Navigate federal and state procurement regulations with expert legal guidance.',
    image: 'https://images.unsplash.com/photo-1745920770891-b46fc1799646?crop=entropy&cs=srgb&fm=jpg&q=85',
    image2: 'https://images.unsplash.com/photo-1752734846552-f91a6e8aa902?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'Government contracts present unique legal challenges. Our experienced attorneys help contractors navigate complex procurement regulations, compliance requirements, and dispute resolution processes.',
    process: [
      { step: 'Registration & Certification', description: 'Assist with SAM registration and small business certifications' },
      { step: 'Bid Preparation', description: 'Review solicitations and prepare compliant proposals' },
      { step: 'Contract Negotiation', description: 'Negotiate terms and ensure regulatory compliance' },
      { step: 'Performance & Compliance', description: 'Ongoing compliance monitoring and issue resolution' }
    ],
    benefits: [
      'Regulatory compliance expertise',
      'Reduced risk of disputes and claims',
      'Competitive bidding support',
      'Contract interpretation and negotiation',
      'Dispute resolution and claims support'
    ],
    faqs: [
      { q: 'What is the FAR?', a: 'The Federal Acquisition Regulation (FAR) is the principal set of rules governing federal government procurement.' },
      { q: 'Do I need special certifications?', a: 'Many government contracts require specific certifications such as small business, veteran-owned, or woman-owned business status.' },
      { q: 'How do I resolve disputes with the government?', a: 'Government contract disputes can be resolved through claims processes, boards of contract appeals, or the Court of Federal Claims.' }
    ]
  },
  'business-disputes': {
    title: 'Business Disputes',
    description: 'Effective resolution of commercial disputes through litigation and alternative dispute resolution.',
    image: 'https://images.unsplash.com/photo-1770943558988-2c605d6bd5a7?crop=entropy&cs=srgb&fm=jpg&q=85',
    image2: 'https://images.unsplash.com/photo-1767972159871-b9f5d320be2b?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'When business disputes arise, swift and strategic action is essential. Our litigation team represents clients in contract disputes, partnership disagreements, fraud claims, and other commercial matters.',
    process: [
      { step: 'Case Assessment', description: 'Evaluate dispute merits and develop litigation strategy' },
      { step: 'Pre-Litigation Resolution', description: 'Attempt negotiated settlement or mediation' },
      { step: 'Litigation', description: 'File complaint, conduct discovery, and prepare for trial' },
      { step: 'Trial or Settlement', description: 'Represent client at trial or negotiate favorable settlement' }
    ],
    benefits: [
      'Experienced trial attorneys',
      'Strategic dispute resolution',
      'Cost-effective litigation management',
      'Alternative dispute resolution expertise',
      'Protection of business interests'
    ],
    faqs: [
      { q: 'Should I try to settle before going to court?', a: 'Settlement often saves time and money. We evaluate all options and recommend the best strategy for your situation.' },
      { q: 'What is arbitration?', a: 'Arbitration is a private dispute resolution process where a neutral arbitrator makes a binding decision instead of going to court.' },
      { q: 'How long do business disputes take to resolve?', a: 'Timeline varies widely depending on complexity, jurisdiction, and whether the case settles or goes to trial. Simple cases may resolve in months, complex litigation can take years.' }
    ]
  },
  'anti-corruption-compliance': {
    title: 'Anti-Corruption Compliance',
    description: 'Comprehensive compliance programs to prevent corruption and bribery.',
    image: 'https://images.unsplash.com/photo-1666018215790-867b14fe4822?crop=entropy&cs=srgb&fm=jpg&q=85',
    image2: 'https://images.unsplash.com/photo-1658664209996-c52a32784ecb?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'Global businesses face increasing anti-corruption scrutiny. We help organizations develop and implement effective compliance programs to meet FCPA, UK Bribery Act, and other international anti-corruption standards.',
    process: [
      { step: 'Risk Assessment', description: 'Identify corruption risks in your business operations' },
      { step: 'Program Development', description: 'Design tailored compliance policies and procedures' },
      { step: 'Training & Implementation', description: 'Train employees and implement compliance program' },
      { step: 'Monitoring & Auditing', description: 'Ongoing monitoring, reporting, and program updates' }
    ],
    benefits: [
      'Reduced legal and regulatory risk',
      'Enhanced reputation and stakeholder confidence',
      'Improved business practices',
      'Protection against penalties and prosecution',
      'Competitive advantage in global markets'
    ],
    faqs: [
      { q: 'What is the FCPA?', a: 'The Foreign Corrupt Practices Act prohibits U.S. companies from bribing foreign officials to obtain or retain business.' },
      { q: 'Who needs anti-corruption compliance?', a: 'Any company doing business internationally or with government entities should have anti-corruption policies and procedures.' },
      { q: 'What are the penalties for violations?', a: 'Penalties can include substantial fines, imprisonment for individuals, debarment from government contracts, and reputational damage.' }
    ]
  },
  'immigration': {
    title: 'Immigration',
    description: 'Comprehensive immigration services for individuals and businesses.',
    image: 'https://images.unsplash.com/photo-1772665762852-d4fe81112ceb?crop=entropy&cs=srgb&fm=jpg&q=85',
    image2: 'https://images.unsplash.com/photo-1655722725332-9925c96dd627?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'Navigating U.S. immigration law requires expertise and precision. We assist individuals and businesses with visa applications, green cards, citizenship, and employment-based immigration matters.',
    process: [
      { step: 'Initial Consultation', description: 'Assess your immigration goals and eligibility' },
      { step: 'Case Preparation', description: 'Gather documentation and prepare application materials' },
      { step: 'Filing & Follow-up', description: 'Submit applications and respond to government requests' },
      { step: 'Interview Preparation', description: 'Prepare clients for consular or USCIS interviews' }
    ],
    benefits: [
      'Expert guidance through complex processes',
      'Increased approval likelihood',
      'Personalized immigration strategy',
      'Timely application preparation',
      'Representation before USCIS'
    ],
    faqs: [
      { q: 'What visa types do you handle?', a: 'We handle all visa categories including H-1B, L-1, O-1, E-2, family-based visas, and more.' },
      { q: 'How long does the green card process take?', a: 'Timeline varies significantly based on visa category and country of origin, ranging from months to several years.' },
      { q: 'Can you help with citizenship applications?', a: 'Yes, we assist with naturalization applications and preparation for citizenship interviews and tests.' }
    ]
  },
  'trademark-registration': {
    title: 'Trademark Registration',
    description: 'Protect your brand with comprehensive trademark services.',
    image: 'https://images.unsplash.com/photo-1666018215790-867b14fe4822?crop=entropy&cs=srgb&fm=jpg&q=85',
    image2: 'https://images.unsplash.com/photo-1633158108216-f10cd3202d8a?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'Your brand is your most valuable asset. Our trademark attorneys help you select strong marks, conduct clearance searches, register trademarks with the USPTO, and enforce your rights against infringement.',
    process: [
      { step: 'Trademark Search', description: 'Conduct comprehensive search for conflicting marks' },
      { step: 'Application Preparation', description: 'Prepare and file trademark application with USPTO' },
      { step: 'Prosecution', description: 'Respond to office actions and navigate examination process' },
      { step: 'Registration & Maintenance', description: 'Secure registration and maintain trademark rights' }
    ],
    benefits: [
      'Nationwide brand protection',
      'Legal presumption of ownership',
      'Exclusive use rights in your industry',
      'Foundation for international protection',
      'Enhanced brand value'
    ],
    faqs: [
      { q: 'How long does trademark registration take?', a: 'USPTO processing typically takes 8-12 months from filing to registration if no issues arise.' },
      { q: 'What can be trademarked?', a: 'Trademarks protect brand names, logos, slogans, and other source identifiers. They cannot protect generic terms or functional features.' },
      { q: 'Do I need to use my trademark before filing?', a: 'You can file an "intent to use" application before actual use, but must demonstrate use before registration issues.' }
    ]
  },
  'copyright-registration': {
    title: 'Copyright Registration',
    description: 'Secure legal protection for your creative works.',
    image: 'https://images.unsplash.com/photo-1666018215790-867b14fe4822?crop=entropy&cs=srgb&fm=jpg&q=85',
    image2: 'https://images.unsplash.com/photo-1593444285553-28163240e3f1?crop=entropy&cs=srgb&fm=jpg&q=85',
    overview: 'Copyright protection is essential for authors, artists, software developers, and content creators. We help you register copyrights, license your works, and enforce your rights against infringement.',
    process: [
      { step: 'Work Assessment', description: 'Evaluate copyrightable elements of your work' },
      { step: 'Registration Filing', description: 'Prepare and submit copyright application to U.S. Copyright Office' },
      { step: 'Certificate Receipt', description: 'Obtain copyright registration certificate' },
      { step: 'Enforcement Strategy', description: 'Develop strategy to protect and monetize your copyrights' }
    ],
    benefits: [
      'Public record of ownership',
      'Right to sue for infringement',
      'Eligibility for statutory damages',
      'Enhanced licensing opportunities',
      'Deterrent against infringement'
    ],
    faqs: [
      { q: 'What can be copyrighted?', a: 'Copyright protects original works of authorship including books, music, art, software, architectural works, and more.' },
      { q: 'Do I have copyright without registration?', a: 'Copyright exists upon creation, but registration provides important legal benefits including the ability to sue for infringement.' },
      { q: 'How long does copyright last?', a: 'For works created after 1978, copyright generally lasts for the life of the author plus 70 years.' }
    ]
  }
};
